import { BacktrackAndGetPreviousQuestionRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/backtrackAndGetPreviousQuestionRPC";
import { BacktrackAndGetPreviousQuestionRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/backtrackAndGetPreviousQuestionRPCClientImpl";
import { BacktrackToFirstUnansweredQuestionRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/backtrackToFirstUnansweredQuestionRPC";
import { BacktrackToFirstUnansweredQuestionRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/backtrackToFirstUnansweredQuestionRPCClientImpl";
import { GenerateGenericSurveyLinkRPC } from "@pulse/pulse-rpcs/lib/survey/generateGenericSurveyLinkRPC";
import { GenerateGenericSurveyLinkRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/generateGenericSurveyLinkRPCClientImpl";
import { GetCurrentQuestionAndSettingsRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/getCurrentQuestionAndSettingsRPC";
import { GetCurrentQuestionAndSettingsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/getCurrentQuestionAndSettingsRPCClientImpl";
import { RestartSurveyRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/restartSurveyRPC";
import { RestartSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/restartSurveyRPCClientImpl";
import { SaveAndGetNextQuestionRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/saveAndGetNextQuestionRPC";
import { SaveAndGetNextQuestionRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/saveAndGetNextQuestionRPCClientImpl";
import { SaveDraftRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/saveDraftRPC";
import { SaveDraftRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/saveDraftRPCClientImpl";
import { StartSurveyRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/startSurveyRPC";
import { StartSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/startSurveyRPCClientImpl";
import { SubmitSurveyRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/submitSurveyRPC";
import { SubmitSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/submitSurveyRPCClientImpl";
import { SwitchLanguageRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/switchLanguageRPC";
import { SwitchLanguageRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/switchLanguageRPCClientImpl";
import { StartChatSurveyRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/startChatSurveyRPC";
import { StartChatSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/startChatSurveyRPCClientImpl";
import { SaveChatSurveyAnswerRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/saveChatSurveyAnswerRPC";
import { SaveChatSurveyAnswerRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/saveChatSurveyAnswerRPCClientImpl";
import { SubmitChatSurveyRPC } from "@pulse/pulse-rpcs/lib/survey-respondent/submitChatSurveyRPC";
import { SubmitChatSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-respondent/submitChatSurveyRPCClientImpl";
import { APIClient } from "@surya-digital/tedwig";
import { MOCK } from "@pulse/shared-components";
import { MockGetCurrentQuestionsAndSettingsClientImpl } from "./MockGetCurrentQuestionsAndSettingsClientImpl";
import { MockSaveAndGetNextQuestionClientImpl } from "./MockSaveAndGetNextQuestionClientImpl";
import { MockRestartSurveyRPCClientImpl } from "./MockRestartSurveyRPCClientImpl";
import { MockBacktrackAndGetPreviousQuestionClientImpl } from "./MockBacktrackAndGetPreviousQuestionClientImpl";
import { MockBacktrackToFirstUnansweredQuestionClientImpl } from "./MockBacktrackToFirstUnansweredQuestionClientImpl";
import { MockStartSurveyRPCClientImpl } from "./MockStartSurveyRPCClientImpl";
import { MockSubmitSurveyRPCClientImpl } from "./MockSubmitSurveyRPCClientImpl";
import { MockSaveDraftClientImpl } from "./MockSaveDraftClientImpl";
import { MockSwitchLanguageRPCClientImpl } from "./MockSwitchLanguageRPCClientImpl";
import { MockGenerateGenericSurveyLinkRPCClientImpl } from "./MockGenerateGenericSurveyLinkRPCClientImpl";
import { MockStartChatSurveyRPCClientImpl } from "./MockStartChatSurveyRPCClientImpl";
import { MockSaveChatSurveyAnswerRPCClientImpl } from "./MockSaveChatSurveyAnswerRPCClientImpl";
import { MockSubmitChatSurveyRPCClientImpl } from "./MockSubmitChatSurveyRPCClientImpl";

export const useGetCurrentQuestionAndSettingsRPCClientImpl = (
  apiClient: APIClient,
): GetCurrentQuestionAndSettingsRPC => {
  if (MOCK.surveyRespondent) {
    return new MockGetCurrentQuestionsAndSettingsClientImpl();
  } else {
    return new GetCurrentQuestionAndSettingsRPCClientImpl(apiClient);
  }
};

export const useSaveAndGetNextQuestionRPCClientImpl = (
  apiClient: APIClient,
): SaveAndGetNextQuestionRPC => {
  if (MOCK.surveyRespondent) {
    return new MockSaveAndGetNextQuestionClientImpl();
  } else {
    return new SaveAndGetNextQuestionRPCClientImpl(apiClient);
  }
};

export const useBacktrackAndGetPreviousQuestionRPCClientImpl = (
  apiClient: APIClient,
): BacktrackAndGetPreviousQuestionRPC => {
  if (MOCK.surveyRespondent) {
    return new MockBacktrackAndGetPreviousQuestionClientImpl();
  } else {
    return new BacktrackAndGetPreviousQuestionRPCClientImpl(apiClient);
  }
};

export const useBacktrackToFirstUnansweredQuestionRPCClientImpl = (
  apiClient: APIClient,
): BacktrackToFirstUnansweredQuestionRPC => {
  if (MOCK.surveyRespondent) {
    return new MockBacktrackToFirstUnansweredQuestionClientImpl();
  } else {
    return new BacktrackToFirstUnansweredQuestionRPCClientImpl(apiClient);
  }
};

export const useRestartSurveyRPCClientImpl = (
  apiClient: APIClient,
): RestartSurveyRPC => {
  if (MOCK.surveyRespondent) {
    return new MockRestartSurveyRPCClientImpl();
  } else {
    return new RestartSurveyRPCClientImpl(apiClient);
  }
};

export const useStartSurveyRPCClientImpl = (
  apiClient: APIClient,
): StartSurveyRPC => {
  if (MOCK.surveyRespondent) {
    return new MockStartSurveyRPCClientImpl();
  } else {
    return new StartSurveyRPCClientImpl(apiClient);
  }
};

export const useSubmitSurveyRPCClientImpl = (
  apiClient: APIClient,
): SubmitSurveyRPC => {
  if (MOCK.surveyRespondent) {
    return new MockSubmitSurveyRPCClientImpl();
  } else {
    return new SubmitSurveyRPCClientImpl(apiClient);
  }
};

export const useSaveDraftRPCClientImpl = (
  apiClient: APIClient,
): SaveDraftRPC => {
  if (MOCK.surveyRespondent) {
    return new MockSaveDraftClientImpl();
  } else {
    return new SaveDraftRPCClientImpl(apiClient);
  }
};

export const useSwitchLanguageRPCClientImpl = (
  apiClient: APIClient,
): SwitchLanguageRPC => {
  if (MOCK.surveyRespondent) {
    return new MockSwitchLanguageRPCClientImpl();
  } else {
    return new SwitchLanguageRPCClientImpl(apiClient);
  }
};

export const useGenerateGenericSurveyLinkRPCClientImpl = (
  apiClient: APIClient,
): GenerateGenericSurveyLinkRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGenerateGenericSurveyLinkRPCClientImpl();
  } else {
    return new GenerateGenericSurveyLinkRPCClientImpl(apiClient);
  }
};

export const useStartChatSurveyRPCClientImpl = (
  apiClient: APIClient,
): StartChatSurveyRPC => {
  if (MOCK.surveyRespondent) {
    return new MockStartChatSurveyRPCClientImpl();
  }
  return new StartChatSurveyRPCClientImpl(apiClient);
};

export const useSaveChatSurveyAnswerRPCClientImpl = (
  apiClient: APIClient,
): SaveChatSurveyAnswerRPC => {
  if (MOCK.surveyRespondent) {
    return new MockSaveChatSurveyAnswerRPCClientImpl();
  }
  return new SaveChatSurveyAnswerRPCClientImpl(apiClient);
};

export const useSubmitChatSurveyRPCClientImpl = (
  apiClient: APIClient,
): SubmitChatSurveyRPC => {
  if (MOCK.surveyRespondent) {
    return new MockSubmitChatSurveyRPCClientImpl();
  }
  return new SubmitChatSurveyRPCClientImpl(apiClient);
};
